<template>
  <div :key="uniqueKey" class="text"
       :class="config.jumpPanelSn ? 'has-jump':''"
       :style="textOuterStyle">
    <img v-if="borderImgUrl" class="text-border" :src="borderImgUrl" alt=""
         :style="textBorderImageStyle">
    <div class="text-block" :style="textBlockStyle">
      {{ config.chartTitle }}
    </div>
  </div>
</template>

<script>
import { imgURLtoBase64 } from '@/utils/common'
import {
  getTitleBarTypographyInlineStyle,
  getTitleBarOffsetInlineStyle,
  getBorderTemplateImageStyle,
} from '@/utils/chartTitlePresets'

export default {
  name: 'TextBlock',
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
    componentType: {
      type: String,
    },
  },
  data () {
    return {
      borderImgUrl: '',
      uniqueKey: 'xxx',

    }
  },
  computed: {
    borderStyle () {
      return this.config.chartSet.borderStyle.borderTemplate
    },
    /** 与原先一致：字号/对齐等仍在组件根上，仅位移作用在文字层 */
    textOuterStyle () {
      return getTitleBarTypographyInlineStyle(this.config?.chartSet?.titleStyle)
    },
    textBlockStyle () {
      return {
        lineHeight: this.config.chartHeight + 'px',
        ...getTitleBarOffsetInlineStyle(this.config?.chartSet?.titleStyle),
      }
    },
    textBorderImageStyle () {
      return getBorderTemplateImageStyle(this.config?.chartSet?.borderStyle)
    },
  },
  watch: {
    async borderStyle (val) {
      if (val) {
        this.borderImgUrl = await imgURLtoBase64(val)
      } else {
        this.borderImgUrl = ''
      }
    },

  },
  created () {
    const ts = this.config?.chartSet?.titleStyle
    if (ts) {
      if (ts.titleOffsetX === undefined) this.$set(ts, 'titleOffsetX', 0)
      if (ts.titleOffsetY === undefined) this.$set(ts, 'titleOffsetY', 0)
      if (ts.fontFamily === undefined) this.$set(ts, 'fontFamily', '')
    }
    this.init()
  },
  methods: {
    async init () {
      if (this.borderStyle) {
        this.borderImgUrl = await imgURLtoBase64(this.borderStyle)
      }
      this.uniqueKey = Math.random()
    },
  },
}
</script>

<style lang="scss" scoped>
.text {
  position: relative;
  width: 100%;
  overflow: visible;
  &.has-jump{
    cursor: pointer;
  }
  &-border {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .text-block{
    cursor: inherit;
    padding: 0 30px;
  }
}

</style>
